import { Request } from '../../../../httpClient/serverApi/requests/Request';

export interface ISetSandboxForAllSitesParams {
    shouldEnable: boolean;
}

export interface ISetSandboxForAllSitesResult {
}

export class SetSandboxSettingsForAllSitesRequest extends Request<ISetSandboxForAllSitesParams, ISetSandboxForAllSitesResult> {
  constructor(params: ISetSandboxForAllSitesParams) {
    super('setSandboxSettingsForAllSites', params);
  }
}
